module.exports = __webpack_public_path__ + "videos/video-768@1x.11ae03a.webm";